<template>
  <div class="tree-node">
    <!-- 节点本身 -->
    <div class="node-content" :style="{ paddingLeft: `${level * 20 + 16}px` }">
      <div class="node-main">
        <!-- 复选框或单选框 -->
        <input 
          v-if="node.checktype == '2'"
          type="radio"
          :name="`radio-${getParentId()}`"
          :checked="node.checked"
          @change="handleCheck($event.target.checked)"
          class="node-checkbox"
        />
        <input 
          v-else
          type="checkbox"
          :checked="node.checked"
          @change="handleCheck($event.target.checked)"
          class="node-checkbox"
        />
        
        <!-- 节点标签 -->
        <span class="node-label">{{ node.name }}</span>
      </div>
      
      <!-- 展开/收起按钮 - 只有一级节点才显示 -->
      <span 
        v-if="hasChildren && level === 0"
        @click="$emit('toggle', node.id)"
        class="toggle-button"
      >
        {{ !node.expanded||node.expanded==undefined ? '−' : '+' }}
     </span>
    </div>
    
    <!-- 子节点 - 二级及以下默认展开 -->
    <div v-if="(!node.expanded||node.expanded==undefined || level > 0) && hasChildren" class="children-container">
      <!-- 如果子节点都是叶子节点，横向排列 -->
      <div v-if="areAllChildrenLeaves" class="horizontal-children" :style="{ paddingLeft: `${(level + 1) * 20 + 16}px` }">
        <div v-for="child in node.child" :key="child.id" class="horizontal-child">
          <input 
            v-if="child.checktype == '2'"
            type="radio"
            :name="`radio-${node.id}`"
            :checked="child.checked"
            @change="handleChildCheck(child.id, $event.target.checked)"
            class="node-checkbox"
          />
          <input 
            v-else
            type="checkbox"
            :checked="child.checked"
            @change="handleChildCheck(child.id, $event.target.checked)"
            class="node-checkbox"
          />
          <span class="node-label">{{ child.name }}</span>
        </div>
      </div>
      
      <!-- 如果有非叶子节点，纵向排列 -->
      <div v-else class="vertical-children">
        <TreeNode 
          v-for="child in node.child" 
          :key="child.id"
          :node="child" 
          :level="level + 1"
          @toggle="$emit('toggle', $event)"
          @check="$emit('check', $event, arguments[1])"
          @child-check="$emit('child-check', $event, arguments[1])"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',
  props: {
    node: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  computed: {
    hasChildren() {
      return this.node.child && this.node.child.length > 0
    },
    areAllChildrenLeaves() {
      if (!this.hasChildren) return false
      return this.node.child.every(child => !child.child || child.child.length === 0)
    }
  },
  methods: {
    getParentId() {
      return this.node.pid
      // return Math.floor(this.node.id / 10)
    },
    handleCheck(checked) {
      this.$emit('check', this.node.id, checked)
      
      // 如果取消选择父级，则取消所有子级选择
      if (!checked && this.hasChildren) {
        this.uncheckAllChildren(this.node)
      }
    },
    handleChildCheck(childId, checked) {
      this.$emit('child-check', childId, checked)
      
      // 如果子级被选中，自动选中父级
      if (checked) {
        this.$emit('check', this.node.id, true)
      }
      // 如果所有子级都未选中，取消父级选择
      else {
        const hasCheckedChildren = this.checkIfHasCheckedChildren(this.node)
        if (!hasCheckedChildren) {
          this.$emit('check', this.node.id, false)
        }
      }
    },
    uncheckAllChildren(node) {
      if (node.child) {
        node.child.forEach(child => {
          this.$emit('child-check', child.id, false)
          if (child.child) {
            this.uncheckAllChildren(child)
          }
        })
      }
    },
    checkIfHasCheckedChildren(node) {
      if (!node.child) return false
      
      return node.child.some(child => {
        return child.checked || this.checkIfHasCheckedChildren(child)
      })
    }
  }
}
</script>

<style scoped lang="less"> 
.tree-node {
  width: 100%; border: 1px solid #DCDCDC;margin-top:-1px;
  .tree-node {border:0px;}
}

.node-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
 
  
  background-color: #fff;
 
}

.node-main {
  display: flex;
  align-items: center;
  flex: 1;
}

.node-checkbox {
  margin-right: 8px;
  width: 16px;
  height: 16px;
  accent-color: #1890ff;
}

.node-label {
  font-size: 18px;
  color: #333;
  user-select: none;
}

.toggle-button {
 
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  font-weight: bold;
  color: #666;
  transition: all 0.2s;
}

.toggle-button:hover {
  border-color: #1890ff;
  color: #1890ff;
}

.children-container {
  /* background-color: #fafafa; */
 
}

.horizontal-children {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px;
}

.horizontal-child {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.vertical-children {

}

/* 单选框样式 */
input[type="radio"] {
  border-radius: 50%;
}

/* 复选框样式 */
input[type="checkbox"] {
  border-radius: 2px;
}
</style>
